module.exports = __webpack_public_path__ + "img/G-Pay-Logo.1dd33a65.svg";